import TransfersPage from "components/pages/TransfersPage";
/**
 * @name CaptureUnlinkedAccountsMakeATransferMain
 * @returns {React.Component}
 * @description 
 * This capture is used in the following capture groups:
 * "Unlinked Accounts" (abi22).
 */
export default function CaptureUnlinkedAccountsMakeATransferMain(props) {
    return <TransfersPage />;
}